export default __webpack_public_path__ + "static/media/ragdoll7XXS.00d4c542.webp";